import { useSuspenseQuery } from '@tanstack/react-query';

type ReleaseInfo = { id: string };

const releaseId = import.meta.env.RELEASE_ID;

const fetchReleaseInfo = async (): Promise<ReleaseInfo> => {
  // Using fetch instead of Axios:
  // response.json() throws an error if the response isn't valid JSON
  // (e.g., if we get index.html instead, like in development)
  const response = await fetch('/release.json');
  try {
    return await response.json();
  } catch {
    return { id: releaseId };
  }
};

export const useIsAppOutdated = () =>
  useSuspenseQuery({
    queryKey: ['releaseCheck'],
    queryFn: fetchReleaseInfo,
    gcTime: 0,
    select: (data) => data.id !== releaseId,
  });
